import React from "react";
var __jsx = React.createElement;
import ContactComponent from "@/pages/contact/ContactComponent/ContactComponent";
import Layout from "@/_LayoutsRelated/layout/Layout";
var Contact = function Contact() {
  return /*#__PURE__*/React.createElement(Layout, {
    hasNavBar: true,
    linksForSearch: true,
    authenticationMsg: true
  }, /*#__PURE__*/React.createElement(ContactComponent, null));
};
export default Contact;